import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './lib/metaPixel';
initMetaPixel();
render(<App data-id="element-313" />, document.getElementById('root'));